import { createContext } from "react";

import { RelatedPerson } from "@medplum/fhirtypes";

interface PartnerContextOptions {
  partners: RelatedPerson[];
  setPartners: (partners: RelatedPerson[]) => void;
  refreshPartners: () => Promise<void>;
}

export const PartnerContext = createContext<PartnerContextOptions>({
  partners: [],
  setPartners: () => null,
  refreshPartners: async () => {},
});
